import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IActa, IAnyos, IDocente, INotificaciones, IPeriodos, ISeccionDocente, ISedes } from 'src/app/interfaces/portal-calificaciones';
import { environment } from 'src/environments/environment';
import { PerfilamientoService } from '../perfilamiento/perfilamiento.service';
import { ISeccionesRes } from 'src/app/interfaces/secciones';

@Injectable({
  providedIn: 'root'
})
export class PortalCalificacionesService {

  constructor(
    private readonly http: HttpClient,
    private readonly _perfilamiento: PerfilamientoService
  ) { }
  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  obtenerListaAnhos(administrativo: boolean = false):Observable<IAnyos> {
    const currEnv = administrativo ? environment.endpointAdministrativo : environment.endpointDocente
    const url = `${currEnv}/v1/ponderacion/individual/obtener-anyos`
    return this.http.get<IAnyos>(url, { headers: this.getHeaders() })
  }
  
  obtenerListaPeriodos(anyo: number, administrativo: boolean = false):Observable<IPeriodos> {
    const currEnv = administrativo ? environment.endpointAdministrativo : environment.endpointDocente
    const url = `${currEnv}/v1/ponderacion/individual/obtener-periodos?anyo=${anyo}`
    return this.http.get<IPeriodos>(url, { headers: this.getHeaders() })
  }
  obtenerListaSedes(anyo: number, periodoId: number, docenteId: number = 0): Observable<ISedes[]> {
    const filtroDocenteBackoffice = docenteId !== 0 ? `&docente-id=${docenteId}` : ''
    const url = `${environment.endpointDocente}/v1/seccion-docente/obtenerSedes?anyo=${anyo}&periodo-id=${periodoId}${filtroDocenteBackoffice}`
    return this.http.get<ISedes[]>(url, { headers: this.getHeaders() })
  }
  obtenerLista(anyo: number, periodoId: number, sedeId: number, docenteId: number = 0): Observable<ISeccionDocente[]> {
    const filtroDocenteBackoffice = docenteId !== 0 ? `&docente-id=${docenteId}` : ''
    const filtroSedes = sedeId !== 0 ? `&sede-id=${sedeId}` : ''
    const url = `${environment.endpointDocente}/v1/seccion-docente/obtenerLista?anyo=${anyo}&periodo-id=${periodoId}${filtroSedes}${filtroDocenteBackoffice}`
    return this.http.get<ISeccionDocente[]>(url, { headers: this.getHeaders() })
  }
  obtenerNotificaciones(): Observable<INotificaciones[]> {
    const url = `${environment.endpointDocente}/v1/seccion-docente/obtenerNotificacion`
    return this.http.get<INotificaciones[]>(url, {headers: this.getHeaders()});
  }
  obtenerDocente(docenteId: number = 0): Observable<IDocente> { 
    const filtroDocenteBackoffice = docenteId !== 0 ? `?docente-id=${docenteId}` : ''
    const url = `${environment.endpointDocente}/v1/seccion-docente/obtenerDocente${filtroDocenteBackoffice}`
    return this.http.get<IDocente>(url, {headers: this.getHeaders()});
  }

  descargarActa(seccionId: number, anyo: number, periodoId: number): Observable<IActa> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/descargarActaCierrre?seccionId=${seccionId}&anyo=${anyo}&periodo-id=${periodoId}`
    return this.http.get<IActa>(url, {headers: this.getHeaders()});
  }

  obtenerListaDocentesBackoffice(anyo: number, periodoId: number, sedeId: number = 0, seccionId: number = 0, pageNo?: number, pageSize?: number, search?: string):Observable<any> {
    const filtroSede = sedeId !== 0 ? `&sede-id=${sedeId}` : ''
    const filtroSeccion = seccionId !== 0 ? `&seccion-id=${seccionId}` : ''
    const filtroPageNo = pageNo ? `&page-no=${pageNo}` : ''
    const filtroPageSize = pageSize ? `&page-size=${pageSize}` : ''
    const filtroSearch = search ? `&search=${search}` : ''
    const url = `${environment.endpointAdministrativo}/v1/docente/obtenerDocentes?anyo=${anyo}&periodo-id=${periodoId}${filtroSede}${filtroSeccion}${filtroPageNo}${filtroPageSize}${filtroSearch}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  obtenerListaSeccionesBackoffice(anyo: number = 0, periodoId: number = 0, sedeId: number = 0, docenteId: number = 0, pageNo?: number, pageSize?: number, search?: string):Observable<ISeccionesRes> {
    const filtroDocente = docenteId !== 0 ? `&docente-id=${docenteId}` : ''
    const filtroPageNo = pageNo ? `&page-no=${pageNo}` : ''
    const filtroPageSize = pageSize ? `&page-size=${pageSize}` : ''
    const filtroSearch = search ? `&search=${search}` : ''
    const url = `${environment.endpointAdministrativo}/v1/docente/obtenerSecciones?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}${filtroDocente}${filtroPageNo}${filtroPageSize}${filtroSearch}`
    return this.http.get<ISeccionesRes>(url, { headers: this.getHeaders() })
  }

  obtenerListaSedesBackoffice(anyo: number = 0, periodoId: number = 0, funcionarioId: number = 0):Observable<any> {
    const filtroFuncionario = funcionarioId !== 0 ? `&funcionario-id=${funcionarioId}` : ''
    const url = `${environment.endpointAdministrativo}/v1/docente/obtenerSedes?anyo=${anyo}&periodo-id=${periodoId}${filtroFuncionario}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }
  
}